  import ReactDOM from 'react-dom/client';
  import App from './App';
  import './index.css';
  import { AuthProvider } from './context/AuthContext';

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <AuthProvider>
      <App />
    </AuthProvider>,
  );
